var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"bookmark-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openBookmarkModal($event)}}},[_c('i',{class:_vm.iconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }